export const HPos2DGroupBy = (array: Array<any>, statKey: string = "ntQty") => {
	//return 2d array with conditinal grouping
	return array.reduce(
		(acc: Array<Array<any>>, d: any) => {
			if (d.ntQty !== "0") {
				// open order
				acc[0] = [...acc[0], d];
			} else {
				// closed order
				acc[1] = [...acc[1], d];
			}
			return acc;
		},
		[[], []]
	);
};